<template>
  <tr>
    <td
      class="boss-center boss-table-4-link-cell"
      data-test="date"
    >
      {{ applicationDate }}
      <div data-test="time">
        {{ applicationTime }}
      </div>
      <span
        v-if="applicant.isCasualInterviewRequest"
        class="pega-casual-interview-request-icon"
        data-test="label-casual-interview-request"
      >話を聞きたい</span>
    </td>
    <td class="boss-center">
      <span data-test="user-id">ID:{{ applicant.user.id }}</span>
      <span v-if="applicant.user.isDuplicatedEntries">
        <br>
        <span
          v-tooltip="{ content: '別職種での応募や、過去1年以内の掲載時に応募があった場合に表示されます。'}"
          class="boss-status-label"
          data-test="duplicate"
        >重複応募
        </span>
      </span>
      <div data-test="member-name">
        {{ memberName }}
      </div>
      <div data-test="member-summary">
        {{ memberSummary }}
      </div>
    </td>
    <td
      class="is-boss-only-pc"
      data-test="job-id"
    >
      求人ID:{{ applicant.job.id }}
      <div data-test="job-name">
        {{ jobName }}
      </div>
    </td>
    <td class="boss-center">
      <div class="boss-layout boss-layout-vertical">
        <div>
          <div class="boss-layout boss-layout-gap-small">
            <div
              v-if="applicant.approachingStatus.scout.isSend"
            >
              <img
                v-tooltip="{ content: 'スカウト'}"
                :class="{ 'boss-icon-end': !applicant.approachingStatus.scout.isEffective }"
                src="@/assets/images/icon-scout.svg"
                data-test="scout-icon"
              >
            </div>
            <div
              v-if="applicant.approachingStatus.offerDm.isSend"
            >
              <img
                v-tooltip="{ content: 'オファーDM'}"
                :class="{ 'boss-icon-end': !applicant.approachingStatus.offerDm.isEffective }"
                src="@/assets/images/icon-offer-dm.svg"
                data-test="dm-icon"
              >
            </div>
            <div
              v-if="applicant.approachingStatus.liked.isSend"
            >
              <img
                v-tooltip="{ content: 'いいね'}"
                :class="{ 'boss-icon-end': !applicant.approachingStatus.liked.isEffective }"
                src="@/assets/images/icon-like.svg"
                data-test="like-icon"
              >
            </div>
          </div>
        </div>
        <div>
          <div class="boss-layout boss-layout-vertical boss-layout-no-gap">
            <div
              v-for="sendingFavor in applicant.approachingStatus.specialFavors"
              :key="sendingFavor.id"
            >
              <span
                v-tooltip="{ content: specialFavorBy(sendingFavor.id).description}"
                :data-test="'special-favor-' + sendingFavor.id"
                :class="{ 'boss-bonus-end': !sendingFavor.isEffective }"
                class="boss-bonus-check-text boss-bonus-check-text-gap-small boss-check-true"
              >{{ sendingFavor.name }}</span>
            </div>
          </div>
          <span
            v-if="pathwayLabel"
            class="pega-dtype-scout-check pega-check-true"
            data-test="label-pathway"
          >{{ pathwayLabel }}</span>
        </div>
      </div>
    </td>
    <message-icon-information :message="applicant.message" />
    <td class="boss-center is-boss-only-pc">
      <span data-test="phase">{{ convertLabelByIdFromMaster(applicant.currentSelection.phaseId, phases) }}</span>
    </td>
    <td class="boss-center is-boss-only-pc">
      <span data-test="status">{{ convertLabelByIdFromMaster(applicant.currentSelection.statusId, allStatuses) }}</span>
    </td>
    <td class="pega-remarks-label is-boss-only-pc">
      <span data-test="remarks">{{ applicant.remarks }}</span>
    </td>
  </tr>
</template>

<script>
import { createDate } from '@/lib/dateUtils.js'
import _ from 'lodash'
import * as parse from '@/lib/parse'
import { mapGetters } from 'vuex'
import { directTypeLabelContainLF } from '@/lib/labelValueMappings'
import MessageIconInformation from '@/components/atoms/MessageIconInformation'

export default {
  components: {
    MessageIconInformation
  },
  props: {
    applicant: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('settings', [
      'phases',
      'allStatuses'
    ]),
    ...mapGetters({
      specialFavorBy: 'specialFavorBy'
    }),
    applicationDate () {
      return createDate(_.get(this.applicant, 'entryDate'))?.format('YY/MM/DD')
    },
    applicationTime () {
      return createDate(_.get(this.applicant, 'entryDate'))?.format('HH:mm')
    },
    memberSummary () {
      const summaries = [_.get(this.applicant, 'user.prefecture.name'), this.parseAge(_.get(this.applicant, 'user.birthday')) + '歳', _.get(this.applicant, 'user.gender.name')]
      return _(summaries).compact().join(' ')
    },
    memberName () {
      return this.applicant.user.lastName + this.applicant.user.firstName
    },
    jobName () {
      if (this.applicant.job.name.length > 20) {
        return this.applicant.job.name.match(/^.{0,20}/) + '...'
      } else {
        return this.applicant.job.name
      }
    },
    pathwayLabel () {
      return _.get(directTypeLabelContainLF, this.applicant.pathway, '')
    }
  },
  methods: {
    parseAge (birthdateString) {
      return parse.age(birthdateString)
    },
    convertLabelByIdFromMaster (id, master) {
      return _.get(_.find(master, { id: id }), 'name', 'ー')
    }
  }
}
</script>
